// preview 專用「豐富門面」demo 靜態示意資料（路線 B）。
// 只被 home_page_v2.js 使用；舊頁與共用元件不受影響。
// 之後路線 C 會把這些換成後台真資料（page-management / news / 活動模組）。

// 跑馬燈快訊（react-fast-marquee 純文字）
export const TICKER_ITEMS = [
  "📢 115年 UDN 中文電子書薦購開始，歡迎全校師生推薦",
  "📅 夏季閱讀系列講座—國家圖書館與科林研發共同主辦，歡迎報名參加",
  "📚 中文圖書採購案第三次選書開放中",
  "🏛️ 走讀岡山・在地文化書籍展覽 即日起至 115/06/30",
  "🔧 系統維修公告：例行維護作業將於離峰時段進行",
];

// 活動花絮相簿（direct image URL；demo_activity_mosaic 直接吃 src）
export const ACTIVITY_PHOTOS = [
  { src: "/activity1.jpg", title: "走讀岡山・在地文化書展" },
  { src: "/activity4.jpg", title: "閱讀推廣活動" },
  { src: "/activity2.jpg", title: "圖書館導覽體驗" },
  { src: "/activity3.jpg", title: "主題書展佈置" },
  { src: "/afatsBanner1.jpeg", title: "介壽圖書館" },
  { src: "/afatsBanner2.jpeg", title: "巨輪圖書館" },
];

// 豐富消息（LatestNewsPage：純文字 title/content/more_content）
export const NEWS_BLOG_TYPE_DATA = [
  {
    blog_type_hidden_name: true,
    blog_type_name: "",
    frontend_column_frontend_component_blog_type_blog_data: [
      {
        blog_id: 9001,
        title: "115/04/29 115年 UDN 中文電子書薦購",
        content:
          "本館開放 UDN 中文電子書薦購，歡迎全校師生線上推薦欲購書單，經審核後納入館藏，充實電子書資源。",
        more_content: "",
        external_link: "",
        extermal_link_check: 1,
        youtube_iframe: null,
        property_json: {},
        blog_type_classify_structure_type_blog_data: [],
      },
      {
        blog_id: 9002,
        title: "115/04/29 夏季閱讀系列講座",
        content:
          "國家圖書館與科林研發共同主辦「夏季閱讀系列閱讀講座」，邀請多位講者分享閱讀與研究心得，歡迎踴躍報名參加。",
        more_content: "",
        external_link: "",
        extermal_link_check: 1,
        youtube_iframe: null,
        property_json: {},
        blog_type_classify_structure_type_blog_data: [],
      },
      {
        blog_id: 9003,
        title: "114/03/30 系統維修公告",
        content:
          "圖書館自動化系統將於離峰時段進行例行維護，維護期間部分線上服務可能短暫中斷，造成不便敬請見諒。",
        more_content: "",
        external_link: "",
        extermal_link_check: 1,
        youtube_iframe: null,
        property_json: {},
        blog_type_classify_structure_type_blog_data: [],
      },
      {
        blog_id: 9004,
        title: "115/03/01 中文圖書採購案第三次選書",
        content:
          "中文圖書採購案第三次選書開放中，歡迎各系所提供推薦書單，共同充實本館館藏。",
        more_content: "",
        external_link: "",
        extermal_link_check: 1,
        youtube_iframe: null,
        property_json: {},
        blog_type_classify_structure_type_blog_data: [],
      },
    ],
  },
];

// 影音專區（Video：youtube_iframe；Big Buck Bunny 為穩定可嵌入之公開影片，僅示意）
const yt = (id) =>
  `<iframe width="100%" height="200" src="https://www.youtube.com/embed/${id}" title="影音" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;

export const VIDEO_BLOG_TYPE_DATA = [
  {
    blog_type_hidden_name: false,
    blog_type_name: "影音專區",
    frontend_column_frontend_component_blog_type_blog_data: [
      {
        blog_id: 9101,
        title: "圖書館導覽影片",
        content: "認識介壽與巨輪圖書館的空間與服務。",
        more_content: "",
        youtube_iframe: yt("aqz-KE-bpKQ"),
        blog_type_classify_structure_type_blog_data: [],
      },
      {
        blog_id: 9102,
        title: "資料庫使用教學",
        content: "電子資源檢索與下載步驟示範。",
        more_content: "",
        youtube_iframe: yt("aqz-KE-bpKQ"),
        blog_type_classify_structure_type_blog_data: [],
      },
      {
        blog_id: 9103,
        title: "閱讀推廣活動紀錄",
        content: "歷年閱讀講座與主題書展精華回顧。",
        more_content: "",
        youtube_iframe: yt("aqz-KE-bpKQ"),
        blog_type_classify_structure_type_blog_data: [],
      },
    ],
  },
];

// 統計面板（DonutProgress：[{name, value}]）— 目前版面已移除館藏統計，保留備用
export const STATS_DONUT_DATA = [
  { name: "中文圖書", value: 82000 },
  { name: "西文圖書", value: 15000 },
  { name: "電子書", value: 46000 },
  { name: "期刊", value: 3200 },
  { name: "視聽資料", value: 5400 },
];

// 消息 Tab 面板（最新消息 / 活動快訊 / 系統公告）
export const NEWS_TABS = [
  {
    key: "news",
    label: "最新消息",
    items: [
      { date: "115/04/29", title: "115年 UDN 中文電子書薦購", desc: "開放全校師生線上推薦欲購書單，經審核後納入館藏。" },
      { date: "115/03/01", title: "中文圖書採購案第三次選書", desc: "歡迎各系所提供推薦書單，共同充實本館館藏。" },
      { date: "115/02/15", title: "電子資料庫使用權限更新", desc: "新增多種試用資料庫，歡迎多加利用。" },
      { date: "114/03/30", title: "系統維修公告", desc: "離峰時段例行維護，部分線上服務短暫中斷。" },
    ],
  },
  {
    key: "event",
    label: "活動快訊",
    items: [
      { date: "115/05/10", title: "夏季閱讀系列講座", desc: "國家圖書館與科林研發共同主辦，歡迎踴躍報名參加。" },
      { date: "115/06/30", title: "走讀岡山・在地文化書展", desc: "在地文化、歷史、建築、宗教等主題書籍展覽。" },
      { date: "115/04/15", title: "新生圖書館導覽", desc: "介壽與巨輪校區導覽場次開放預約。" },
    ],
  },
  {
    key: "notice",
    label: "系統公告",
    items: [
      { date: "115/05/01", title: "電子資源連線異常已排除", desc: "HyRead／華藝線上圖書館連線已恢復正常。" },
      { date: "115/04/20", title: "館際合作服務時間調整", desc: "暑假期間 ILL 收件時間異動，詳見公告。" },
    ],
  },
];

// 書單展示示意（Koha DB 未接，先示意；接通後改用 NewArrivalsListShow 真資料）
export const BOOK_LIST = {
  task_name: "熱門新進館藏",
  books: [
    { title: "資訊安全管理領導力實戰手冊", author: "屠震", color: "#1e3a8a" },
    { title: "從子彈到戰術轉變", author: "二見龍", color: "#b91c1c" },
    { title: "本屋大賞 TOP4", author: "夏川草介", color: "#065f46" },
    { title: "零件原理學習法", author: "趙咏翔", color: "#7c2d12" },
    { title: "窗外", author: "瓊瑤", color: "#9d174d" },
    { title: "在地文化的故事", author: "岡山文史工作室", color: "#4338ca" },
    { title: "圖書館與資訊科學導論", author: "王振鵠", color: "#0f766e" },
    { title: "航空工程概論", author: "李國安", color: "#334155" },
  ],
};
